// eslint-disable-next-line
const checkEnvironment = () => {
  return window.envConfig || {};
};

export default checkEnvironment;
